import React from 'react';
import { useTranslation } from 'react-i18next';
import V2Analytics from '../admin/V2Analytics';
import V2AdminPageHeading from '../components/V2AdminPageHeading';

const V2AdminAnalytics: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <>
      <V2AdminPageHeading
        title={t('admin_analytics_title')}
        description={t('admin_analytics_subtitle')}
      />
      <div className="v2-admin-analytics">
        <V2Analytics />
      </div>
    </>
  );
};

export default V2AdminAnalytics;
